import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { DetailFormComponentsEnum } from "@/lib/enum/detail-form-components.enum";
import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { Form, FormConfig, IsFormable } from "@/lib/formable";
import { RulesEnum } from "@/lib/rules/rules.map";
import {
  MrfiktivBillingProfileDtoGen,
  MrfiktivBillingProfileViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
@IsFormable
class BillingProfileBase implements MrfiktivBillingProfileViewModelGen {
  @FormConfig({
    category: "objects.contract.customer.billing",
    searchKeywords: ["objects.person.billingProfile.note", "objects.contract.customer.billing"],
    type: DetailFormComponentsEnum.TEXT_AREA,
    props: {
      label: "objects.person.billingProfile.note"
    }
  })
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.person.billingProfile.note"
  })
  note?: string | undefined | null;

  @FormConfig({
    category: "objects.contract.customer.billing",
    searchKeywords: ["objects.person.billingProfile.paymentTerm", "objects.contract.customer.billing"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      type: "number",
      label: "objects.person.billingProfile.paymentTerm"
    },
    rules: [RulesEnum.REQUIRED_RULE]
  })
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.person.billingProfile.paymentTerm"
  })
  paymentTerm: number;

  bankingId?: string | undefined;

  @FormConfig({
    category: "objects.contract.customer.billing",
    searchKeywords: ["common.nouns.email"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      label: "common.nouns.email"
    },
    rules: [RulesEnum.REQUIRED_RULE, RulesEnum.EMAIL_RULE]
  })
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "common.nouns.email"
  })
  email: string | null;

  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contract.currency" })
  currency?: CurrencyEnum | null;

  @FormConfig({
    category: "objects.contract.customer.billing",
    searchKeywords: ["objects.person.billingProfile.purchaseOrderNumber"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      label: "objects.person.billingProfile.purchaseOrderNumber"
    },
    rules: []
  })
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.person.billingProfile.purchaseOrderNumber"
  })
  purchaseOrderNumber?: string | null;

  @FormConfig({
    category: "objects.contract.customer.billing",
    searchKeywords: ["objects.person.billingProfile.invoiceSubjectLine"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      label: "objects.person.billingProfile.invoiceSubjectLine"
    },
    rules: []
  })
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.person.billingProfile.invoiceSubjectLine"
  })
  invoiceSubjectLine?: string | null;

  @FilterConfig({ type: FilterTypes.ENUM, displayName: "objects.contract.customer.billingType" })
  type?: "flat_rate" | "monthly" | "quarterly" | "semiannual" | "annual" | null;

  @FilterConfig({ type: FilterTypes.ENUM, displayName: "objects.contract.customer.billingMode" })
  mode?: "individual" | "collective" | null;

  get dto(): MrfiktivBillingProfileDtoGen {
    return {
      note: this.note,
      paymentTerm: Number(this.paymentTerm),
      email: this.email,
      currency: this.currency,
      purchaseOrderNumber: this.purchaseOrderNumber,
      invoiceSubjectLine: this.invoiceSubjectLine,
      type: this.type,
      mode: this.mode
    };
  }

  readonly isUpdateable = true;

  constructor(data?: Partial<MrfiktivBillingProfileViewModelGen>) {
    this.note = data?.note;
    this.paymentTerm = data?.paymentTerm ?? 0;
    this.email = data?.email ?? null;
    this.currency = data?.currency as CurrencyEnum;
    this.purchaseOrderNumber = data?.purchaseOrderNumber;
    this.invoiceSubjectLine = data?.invoiceSubjectLine;
    this.type = data?.type;
    this.mode = data?.mode;
  }
}
type IBillingProfile = BillingProfileBase;
const BillingProfile = Form.createForClass(Filter.createForClass(BillingProfileBase));

export { BillingProfile, IBillingProfile };
